<template>
  <div>
    <v-btn v-if="isVisible" class="blink ms-3" @click="jump()" icon dark>
      <v-icon :color="color" style="animation: inherit; -webkit-animation: inherit">chat</v-icon>
    </v-btn>
  </div>
</template>

<script>
import { i18n } from "../plugins/i18n";

export default {
  props: {
    color: {
      type: String,
      default: "#FFFFFF",
    },
  },
  data: function () {
    return {
      isVisible: false,
    };
  },
  methods: {
    jump: function () {
      this.$router.push(`/${i18n.locale}/conversations`);
    },
  },
  mounted() {
    this.isVisible = false;
    // this.isVisible = this.$store.getters.unreadMessageData.length > 0;
    // this.$store.watch(
    //   (state, getters) => getters.unreadMessageData,
    //   (newValue, oldValue) => {
    //     this.isVisible = newValue.length > 0;
    //   }
    // )
  },
};
</script>

<style>
@keyframes blink-animation {
  to {
    visibility: hidden;
  }
}

@-webkit-keyframes blink-animation {
  to {
    visibility: hidden;
  }
}

.blink span {
  animation: blink-animation 1s steps(2, start) infinite;
  -webkit-animation: blink-animation 1s steps(2, start) infinite;
}
</style>
